// src/pages/MainPage.jsx
import React, { useState } from "react";
import PromoBannerWithModal from '../components/PromoBannerWithModal';
import HeroSection from "../components/HeroSection/HeroSection";
import Hero from "../components/Hero/Hero";
import MediaPlayer from "../components/MediaPlayer/MediaPlayer";
import PreorderModal from '../components/PreorderModal/PreorderModal';
import VideoPlayer from "../components/VideoPlayer/VideoPlayer";
import About from "../components/About/About";
import NovelSection from "../components/NovelSection/NovelSection";
import ArtworkCarousel from "../components/ArtworkCarousel/ArtworkCarousel";
import StoreSection from "../components/StoreSection/StoreSection";
import FAQ from "../components/FAQ/FAQ";
import Contact from "../components/Contact/Contact";
import videoAlbums from "../data/videoAlbums";
import musicAlbums from "../data/musicAlbums";
import PricingSection from '../components/PricingSection';

function MainPage() {
  return (
    <>

<PromoBannerWithModal />
      <HeroSection />
      <div id="home">
        <Hero />
      </div>

      <section id="pricing">
        <PricingSection />
      </section>

      {/* 🎵 MUSIC SECTION */}
      <section className="block-container" id="albums">
        <h2>Music Albums</h2>
        <MediaPlayer albums={musicAlbums} />
        <a href="/store" className="see-all-link">
          See all albums in the store →
        </a>
      </section>

      {/* 🎬 VIDEO SECTION */}
      <section className="block-container" id="videos">
        <h2>Video Albums</h2>
        <VideoPlayer albums={videoAlbums} />
      </section>

      <About id="about" />

      <section id="novels">
        <NovelSection />
      </section>

      {/* 🖼️ ART CAROUSEL — images loaded from admin dashboard */}
      <ArtworkCarousel />

<section id="art-carousel" className="block-container">
  <h2>Featured Art</h2>
  <ArtworkCarousel />
</section>


      <section id="featured">
        <StoreSection />
      </section>

      <section id="faqs">
        <FAQ />
      </section>

      <Contact />
    </>
  );
}

export default MainPage;
